import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/dh.png';
const _hoisted_1 = {
  class: "container"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0,
  alt: ""
}, null, -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "head-text"
}, "建立隐私保护服务", -1);

const _hoisted_4 = {
  class: "line-text"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 为保护您和车主双方隐私，请支付 ");

const _hoisted_6 = {
  class: "blue-text"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 押金建立隐私号码保护 ");

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "line-text"
}, [/*#__PURE__*/_createTextVNode(" 通话结束后，系统将 "), /*#__PURE__*/_createElementVNode("span", {
  class: "blue-text"
}, "1小时内"), /*#__PURE__*/_createTextVNode(" 全额退还到我的钱包，不收取任何费用 ")], -1);

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 立即呼叫 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.amount) + "元", 1), _hoisted_7]), _hoisted_8, _createVNode(_component_van_button, {
    round: "",
    block: "",
    type: "primary",
    onClick: _ctx.onAuthPay,
    style: {
      "margin": "60px 40px 0 40px"
    }
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }, 8, ["onClick"])]);
}